import type { KindAdapted } from "~/common/interfaces/entities/kind.interface";

export const getKindDefault = (): KindAdapted => ({
	id: 0,
	name: "",
	namePlural: "",
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	translations: []
});
